var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-info text-align-center"},[(_vm.icon)?_c('FlatIcon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('div',[_vm._t("default",[_c('p',[_vm._v(_vm._s(_vm.message))])])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }